import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class StaffApi extends ApiModule {
	constructor() {
		super(ModulesMap.STAFF, {
			entity: 'staff',
		})
	}

	setPermissions(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'set_permissions',
			}),
			requestOptions: {
				method: 'PATCH',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}
}
